import React, {Component} from 'react';
import {HEADER} from '@optimaxdev/analytics/mobile';

import {MenuArrowIcon} from 'features/menu/helpers/icons/menuArrow/menuArrow';
import {sendAnalytics} from 'libs/analytics/sendAnalytics';

import s from './accessibility.scss';

/**
 * Renders the Accessibility
 */
export class Accessibility extends Component {
    /**
     * Send analytics on click
     */
    onClick = () => {
        sendAnalytics(HEADER.BUTTON, {
            buttonName: 'Accessibility',
            label: '',
        });
    };

    /**
     * Render jsx to html
     * @returns {JSX.Element} Rendered react component
     */
    render() {
        return (
            <div role="presentation" className={s.link} onClick={this.onClick}>
                <button type="button" data-acsb="trigger" id="ascbButton">
                    Accessibility View
                    <MenuArrowIcon className={s.arrow} />
                </button>
            </div>
        );
    }
}
